import CourseSchedulingEnrollmentScreen from './containers/courseSchedulingEnrollmentScreen'

export {default as CourseSchedulingEnrollmentScreenLayout} from './components/courseSchedulingEnrollmentScreenLayout'

export default CourseSchedulingEnrollmentScreen
